<template>
  <div class="main">
    <div>
      <div class="small_main_container" id="successChangePassword">
        <div>
          <div>
            Poprawnie zmieniono hasło
          </div>
          <i class="far fa-check-circle" style="font-size: 40px"></i>
          <div class="smallText">
            <div>
              Proces odzyskania hasła do konta dobiegł końca. Możesz się zalogować do swojego konta.
              Dziękujemy, że jesteś z nami.
              Zachęcamy do polubienia nas na Facebooku oraz Instagramie.
            </div>
            <div class="social">
              <div class="social facebook" @click="globalGoTo('https://www.facebook.com/TaPo24/','Link do strony ', 'web', 'SOCIAL')">
                <div class="icon social facebook"><span><i class="fab fa-facebook-f"></i></span></div>
              </div>
              <div class="social instagram" @click="globalGoTo('https://www.instagram.com/tapo24.pl/','Link do strony IG', 'web', 'SOCIAL')">
                <div class="icon social instagram"><span><i class="fab fa-instagram"></i></span></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="footer" @click="click_to_login" id="footerActivate" v-if="uidExist">
        Zaloguj się <i class="fa-regular fa-hand-pointer"></i>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SuccessChangePassword.vue',
  data () {
    return {
      uidExist: false
    }
  },
  methods: {
    click_to_login () {
      this.$router.push({ name: 'Login' })
    }
  },
  mounted () {
    const UID = localStorage.getItem('UID')
    if (UID) {
      this.uidExist = true
    }
  }
}
</script>

<style scoped lang="scss">
@import "@/views/main_layout.scss";
@import "@/views/others.scss";

#successChangePassword {
  font-family: $text-family;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-size: 20px;
}
#footerActivate {
  justify-content: center;
}
.smallText {
  font-size: 12px;
  overflow-wrap: normal;
}
.social{
  display: inline-flex;
  list-style: none;
}
.social .icon{
  background: #293241;
  color: #ee6c4d;
  border-radius: 50%;
  padding: 5px;
  width: 15px;
  height: 15px;
  font-size: 18px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  box-shadow: 0 10px 10px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  transition: all 0.2s cubic-bezier(0.68, -0.55, 0.265, 1.55);
}
.footer{
  margin: 10px 10px;
  width: auto;
  background-color: #3D5A80;
  border-radius: 8px;
  padding: 20px 10px;
  height: min-content;
  font-family: $text-family;
  font-weight: bold;
  text-align: center;
  transition: 0.5s;
}
.footer:hover {
  cursor: pointer;
  background-color: #9cbad3;
}
@media only screen and (min-width: 700px) {
  .small_main_container {
    width: 400px;
  }
}
</style>
